import { ComponentType } from 'react';

import { ParameterClass, Selector } from '~pages/SipConfiguration/domain';

import DefaultSelector from './DefaultSelector';
import DTFMSelector from './DTFMSelector';

export const SelectorTypes: Record<ParameterClass, ComponentType<Selector>> = {
  [ParameterClass.CmpContact]: DefaultSelector,
  [ParameterClass.CmpDialler]: DefaultSelector,
  [ParameterClass.CmpDTMF]: DTFMSelector,
  [ParameterClass.CmpLex]: DefaultSelector,
  [ParameterClass.CmpLiteral]: DefaultSelector,
  [ParameterClass.CmpQueue]: DefaultSelector,
};
